import RefreshIcon from "@assets/images/refresh-primary.svg";
import { Box, Button, Grid } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import FormField from "@saleor/components/FormField/FormField";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

import useStyles from "./styles";
interface RouterProps {
  formData: any;
  formikData: any;
  getPmtSearch: any;
  setDataPmtSearch: any;
  setHasError: any;
  loading: boolean;
  saleOrg: string;
}
const SearchPMTForm: React.FC<RouterProps> = ({
  formData,
  formikData,
  getPmtSearch,
  setDataPmtSearch,
  setHasError,
  loading = false,
  saleOrg
}) => {
  const classes = useStyles();
  const [isFormHasChange, setIsFormHasChange] = useState<boolean>(true);
  const isLoading = loading || isFormHasChange;

  useEffect(() => {
    if (!formikData.dirty) {
      setIsFormHasChange(true);
      return;
    }
    setIsFormHasChange(false);
  }, [formikData.values]);

  const getFilteredObjectWithValues = obj => {
    const filteredEntries = Object.entries(obj).filter(
      ([_key, value]) => value !== ""
    );
    return Object.fromEntries(filteredEntries);
  };

  const onSearch = () => {
    getPmtSearch({
      variables: {
        filter: getFilteredObjectWithValues(formikData.values),
        saleOrg: saleOrg || ""
      }
    });
  };

  const handleResetForm = () => {
    formikData.resetForm();
    setDataPmtSearch({});
    setHasError(false);
  };

  return (
    <div>
      <Grid container spacing={2}>
        {formData.map(field => (
          <FormField
            gridStyle={{ alignSelf: "flex-end" }}
            {...field}
            value={formikData.values[field.name]}
            handleChange={formikData.handleChange}
            id={field.name}
          />
        ))}
      </Grid>
      <Box className={classes.flex}>
        <Box mr={2}>
          <Button
            id="searchPMTButton"
            data-testid="searchPMTButton"
            disabled={isLoading}
            className={classes.actionButton}
            variant={"contained"}
            color={"secondary"}
            onClick={() => onSearch()}
          >
            <SearchIcon style={{ fontSize: "2.4rem" }} />
            <FormattedMessage defaultMessage="ค้นหา" />
          </Button>
        </Box>
        <Box>
          <Button
            id="resetPMTDataButton"
            data-testid="resetPMTDataButton"
            disabled={isLoading}
            className={classNames(
              classes.actionButton,
              isFormHasChange && classes.disableBtn
            )}
            variant={"outlined"}
            color={"secondary"}
            onClick={handleResetForm}
          >
            <SVG src={RefreshIcon} width={24} height={24} />
            <FormattedMessage defaultMessage="ล้างข้อมูล" />
          </Button>
        </Box>
      </Box>
    </div>
  );
};
export default SearchPMTForm;
